'use client'

import React, { ReactElement, useState } from 'react'
import { useWizardSelector } from '@/components/ui/wizard/WizardState'
import { useDispatch } from 'react-redux'
import DropDown from '@/components/ui/wizard/filter/DropDown'
import { setRating } from '../WizardActions'
import { StarsWithoutRating } from '@/components/common/stars'
import { FilterButton } from '@/components/ui/wizard/filter/FilterButton'
import { useTranslations } from 'next-intl'
import FilterLabel from '@/components/ui/wizard/filter/FilterLabel'

export enum RatingValues {
  OK = 'ok',
  GOOD = 'good',
  VERY_GOOD = 'veryGood',
  EXCELLENT = 'excellent',
}

export function RatingDropDown(): ReactElement {
  const ratingInStore = useWizardSelector((state) => state.rating)
  const [rating, setRatingLocalState] = useState(ratingInStore)
  const dispatch = useDispatch()
  const t = useTranslations('SearchPage')

  return (
    <DropDown
      reset={() => setRatingLocalState(undefined)}
      apply={() => dispatch(setRating(rating))}
      resetLabel={t('filterOptionReset')}
      id="order"
      rightAligned={true}
    >
      <Rating rating={rating} setRatingLocalState={setRatingLocalState} />
    </DropDown>
  )
}

export default function Rating(props: {
  rating: RatingValues | undefined
  setRatingLocalState: (r: RatingValues | undefined) => void
}): ReactElement {
  const t = useTranslations('SearchPage.Rating')
  function toggleRating(rating: RatingValues): void {
    if (props.rating === rating) {
      props.setRatingLocalState(undefined)
    } else {
      props.setRatingLocalState(rating)
    }
  }

  return (
    <div className="mb-6 grid">
      <FilterLabel label={'SearchPage.labelRating'} />
      <div className="no-scrollbar -mx-10 flex items-center gap-x-4 overflow-x-scroll px-10 md:overflow-visible">
        <FilterButton
          selected={props.rating === RatingValues.OK}
          onClick={() => toggleRating(RatingValues.OK)}
        >
          <div className="flex">
            <StarsWithoutRating rating={3} />
          </div>
          {t('ok')}
        </FilterButton>
        <FilterButton
          selected={props.rating === RatingValues.GOOD}
          onClick={() => toggleRating(RatingValues.GOOD)}
        >
          <div className="flex">
            <StarsWithoutRating rating={3.5} />
          </div>
          {t('good')}
        </FilterButton>
        <FilterButton
          selected={props.rating === RatingValues.VERY_GOOD}
          onClick={() => toggleRating(RatingValues.VERY_GOOD)}
        >
          <div className="flex">
            <StarsWithoutRating rating={4} />
          </div>
          {t('veryGood')}
        </FilterButton>
        <FilterButton
          selected={props.rating === RatingValues.EXCELLENT}
          onClick={() => toggleRating(RatingValues.EXCELLENT)}
        >
          <div className="flex">
            <StarsWithoutRating rating={4.5} />
          </div>
          {t('excellent')}
        </FilterButton>
      </div>
    </div>
  )
}
